import { keyframes } from "styled-components";
const checkboxEffect = keyframes`
  from {
    opacity: 0.5;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(1.6);
  }
`;
const fadeInEffect = keyframes`
  to {
    opacity: 1;
  }
`;
keyframes`
  to {
    opacity: 0;
  }
`;
keyframes`
  to {
    left: 50%;
    opacity: 1;
    top: 50%;
  }
`;
const rotateEffect = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
keyframes`
  from {
    opacity: 0.5;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(1.3);
  }
`;
export {
  checkboxEffect,
  fadeInEffect,
  rotateEffect
};
